/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketdocumentlinkinvaliderror4Inputs */

const en_ticketdocumentlinkinvaliderror4 = /** @type {(inputs: Ticketdocumentlinkinvaliderror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The link has expired. Please open the document again.`)
};

const de_ticketdocumentlinkinvaliderror4 = /** @type {(inputs: Ticketdocumentlinkinvaliderror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Link ist abgelaufen. Bitte öffne das Dokument nochmal.`)
};

/**
* | output |
* | --- |
* | "The link has expired. Please open the document again." |
*
* @param {Ticketdocumentlinkinvaliderror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketdocumentlinkinvaliderror4 = /** @type {((inputs?: Ticketdocumentlinkinvaliderror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketdocumentlinkinvaliderror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketdocumentlinkinvaliderror4(inputs)
	return de_ticketdocumentlinkinvaliderror4(inputs)
});
export { ticketdocumentlinkinvaliderror4 as "ticketDocumentLinkInvalidError" }